var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.5114C31 19.3263 29.6111 21.6293 27.8136 21.9705C27.6502 22.5676 27.2417 22.9941 26.6698 23.1647C26.5064 23.25 26.343 23.25 26.0979 23.25C25.8528 23.25 25.6077 23.25 25.4443 23.1647C24.709 22.9088 24.2188 22.2264 24.2188 21.3734V11.6494C24.2188 10.8817 24.709 10.114 25.3626 9.8581C25.526 9.7728 25.7711 9.6875 26.0162 9.6875C26.1796 9.6875 26.4247 9.6875 26.5881 9.7728C27.16 9.9434 27.6502 10.4552 27.8136 11.0523C27.8136 11.0523 27.8136 11.0523 27.8136 11.1376C27.8136 11.1376 27.8136 11.1376 27.8953 11.1376C29.6928 11.3935 31 13.6965 31 16.5114Z",
    fill: "#F68140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6406 11.1406H25.4208C25.4208 5.69229 20.9483 1.21978 15.5 1.21978C10.0517 1.21978 5.57915 5.69229 5.57915 11.1406H4.35938C4.35938 4.96042 9.3198 0 15.5 0C21.6802 0 26.6406 5.04174 26.6406 11.1406Z",
    fill: "#F68140"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 11.6371V21.3004C6.78125 22.4023 5.97396 23.25 4.92448 23.25C4.19792 23.25 3.47135 22.7414 3.22917 21.9785C3.14844 21.9785 3.14844 21.9785 3.06771 21.9785C1.29167 21.5547 0 19.266 0 16.4687C0 13.6715 1.3724 11.3828 3.14844 11.0438C3.3099 10.4504 3.79427 9.9418 4.35937 9.77227C4.52083 9.6875 4.76302 9.6875 4.92448 9.6875C5.16667 9.6875 5.32812 9.77227 5.57031 9.85703C6.21615 10.1113 6.70052 10.7895 6.78125 11.6371Z",
    fill: "#F68140"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9263 28.0937H18.4062V26.9184H20.9263C23.7823 26.9184 25.3783 25.4297 25.3783 22.7656H26.6383C26.7223 26.0565 24.5383 28.0937 20.9263 28.0937Z",
    fill: "#F68140"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.777 26.609C18.536 25.7561 17.813 25.1875 17.0097 25.1875H13.957C12.9127 25.1875 12.1094 26.1352 12.1094 27.3672C12.1094 28.5992 12.9127 29.5469 13.957 29.5469H17.0097C17.813 29.5469 18.4557 28.9783 18.777 28.1253C18.8573 27.9358 18.8574 27.6515 18.8574 27.3672C18.9377 27.0829 18.8573 26.7986 18.777 26.609Z",
    fill: "#F68140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer_support.673df91f0cd04bff6d476e53b7d84dba.svg";
export { ForwardRef as ReactComponent };